import { DatePickerInput as MantineDatePickerInput, DatePickerInputProps as MantineDatePickerInputProps } from '@mantine/dates';
import { useMemo, useState } from 'react';

interface DatePickerInputProps extends MantineDatePickerInputProps {
  badgeMessage?: string;
  badgeIcon?: string;
  'data-pw'?: string;
}

export const DatePickerInput: React.FC<DatePickerInputProps> = (props) => {
  const [focused, setFocused] = useState(false);

  const floating = useMemo(() => {
    return !!props.value || focused ? true : undefined;
  }, [props.value, focused]);

  const handleFocus = (evt) => {
    setFocused(true);
    props.onFocus?.(evt);
  };

  const handleBlur = (evt) => {
    setFocused(false);
    props.onBlur?.(evt);
  };

  return (
    <MantineDatePickerInput
      data-pw={props['data-pw']}
      {...(props as any)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      data-floating={floating}
      labelProps={{ ...props.labelProps, 'data-floating': floating, 'data-error': props.error }}
    />
  );
};
